import { environment } from '../../environments/environment';

/**
 * Whether a site's zones are hidden from the current user.
 *
 * Some operators (Wels Traunpark TG) run their site as one area and do not want zones shown to their
 * staff. For those sites only an Administrator sees zones; everyone else gets no zone picker, no zone
 * labels and no zone list on the space page.
 *
 * Hiding the picker needs nothing extra on save: a right with no zones is a space-wide right, which
 * every policy strategy already treats as "all zones" — including zones added to the site later.
 *
 * TEMPORARY: the site list lives in `environment.zonesHiddenForSpaces` until a Keycloak policy owns
 * this decision. Adding a site means a frontend deploy.
 */
export function areZonesHidden(parkingSpaceId: string | null | undefined, isAdministrator: boolean): boolean {
  if (isAdministrator || !parkingSpaceId) return false;
  return environment.zonesHiddenForSpaces.includes(parkingSpaceId);
}
